export const siteConfig = {
  name: '日韩在线永久域名',
  tagline: '稳定不丢失的访问入口',
  description: '日韩在线永久域名 - 为您提供最新、最稳定的日韩在线永久域名收录，告别频繁换址烦恼，永久书签收藏，随时畅享日韩正版内容，域名持续更新维护，确保您的访问从不中断。',
  keywords: '日韩在线永久域名,日韩在线永久域名最新地址,日韩视频永久域名,日韩在线不封域名,日韩永久免费域名入口,日韩在线网站永久地址,稳定日韩域名收录',
  url: 'https://japanlink.github.io',
  foundingYear: '2020',
  email: 'contact@rihan-domain.com',
  wechat: 'rihan_domain_official',
  qq: '4001234567',
};

export const categories = [
  { id: 'video', name: '日韩视频', slug: 'video', icon: 'ri-movie-line', description: '日韩影视视频永久访问域名汇总', count: 28 },
  { id: 'anime', name: '日韩动漫', slug: 'anime', icon: 'ri-ancient-gate-line', description: '日韩动漫番剧稳定域名地址', count: 22 },
  { id: 'variety', name: '日韩综艺', slug: 'variety', icon: 'ri-tv-line', description: '日韩综艺节目永久域名入口', count: 15 },
  { id: 'music', name: '日韩音乐', slug: 'music', icon: 'ri-music-line', description: '日韩音乐MV在线域名合集', count: 18 },
  { id: 'news', name: '日韩资讯', slug: 'news', icon: 'ri-newspaper-line', description: '日韩娱乐资讯域名收录', count: 12 },
  { id: 'live', name: '日韩直播', slug: 'live', icon: 'ri-live-line', description: '日韩直播平台稳定域名入口', count: 10 },
];

export const domains = [
  { id: 'd001', name: '樱花动漫岛', url: 'https://www.yinghua-dm01.com', category: 'anime', status: 'online', updateTime: '2026-08-10', visits: 158000, description: '专注日韩动漫的在线观看平台，提供高清动漫番剧，每日更新最新剧集，支持多种清晰度切换。', tags: ['动漫', '高清', '日漫'], featured: true },
  { id: 'd002', name: '韩剧星球', url: 'https://www.hanju-planet.com', category: 'video', status: 'online', updateTime: '2026-08-11', visits: 234000, description: '最新最全的韩剧在线观看网站，涵盖韩剧、韩影、韩国综艺等丰富内容，中文字幕同步更新。', tags: ['韩剧', '韩影', '综艺'], featured: true },
  { id: 'd003', name: '东京动漫城', url: 'https://www.tokyo-acg.net', category: 'anime', status: 'online', updateTime: '2026-08-09', visits: 189000, description: '海量日漫资源在线观看，从经典老番到最新新番一应俱全，支持弹幕互动。', tags: ['日漫', '弹幕', '新番'], featured: true },
  { id: 'd004', name: '韩综大本营', url: 'https://www.hanzong-camp.com', category: 'variety', status: 'online', updateTime: '2026-08-11', visits: 92000, description: 'Running Man、无限挑战等热门韩综全集在线，中字翻译及时更新。', tags: ['韩综', 'RunningMan', '中字'], featured: false },
  { id: 'd005', name: 'J-POP音乐站', url: 'https://www.jpop-music.site', category: 'music', status: 'online', updateTime: '2026-08-08', visits: 67000, description: '日本流行音乐MV、演唱会、音乐节目在线观看，AKB48、嵐、Official髭男dism等热门歌手全收录。', tags: ['J-POP', 'MV', '演唱会'], featured: false },
  { id: 'd006', name: '日剧时光机', url: 'https://www.riju-time.com', category: 'video', status: 'online', updateTime: '2026-08-10', visits: 145000, description: '经典日剧与新番日剧在线观看，重温那些年我们追过的日剧，中文字幕高清画质。', tags: ['日剧', '经典', '高清'], featured: true },
  { id: 'd007', name: 'K-POP星空', url: 'https://www.kpop-stars.net', category: 'music', status: 'online', updateTime: '2026-08-11', visits: 203000, description: '韩国K-POP打歌舞台、MV、综艺放送在线观看，BTS、BLACKPINK、TWICE等顶流全收录。', tags: ['K-POP', '打歌', 'MV'], featured: true },
  { id: 'd008', name: '动漫狂想曲', url: 'https://www.acg-rhapsody.org', category: 'anime', status: 'online', updateTime: '2026-08-07', visits: 112000, description: '包含日漫、国漫的综合性动漫平台，提供弹幕、评论、收藏等互动功能。', tags: ['综合动漫', '弹幕', '收藏'], featured: false },
  { id: 'd009', name: '韩影世界', url: 'https://www.kr-movie.world', category: 'video', status: 'offline', updateTime: '2026-08-05', visits: 78000, description: '韩国电影在线观看平台，涵盖动作、爱情、悬疑等多种类型，提供中文字幕。', tags: ['韩影', '动作', '爱情'], featured: false },
  { id: 'd010', name: '日韩综艺汇', url: 'https://www.rh-variety.top', category: 'variety', status: 'online', updateTime: '2026-08-10', visits: 54000, description: '日韩热门综艺合集，从搞笑到真人秀，一网打尽最新最热综艺内容。', tags: ['综艺', '搞笑', '真人秀'], featured: false },
  { id: 'd011', name: '二次元入口', url: 'https://www.2d-gate.xyz', category: 'anime', status: 'online', updateTime: '2026-08-09', visits: 134000, description: '二次元爱好者的一站式入口，动漫、漫画、轻小说资源丰富，社区氛围活跃。', tags: ['二次元', '漫画', '轻小说'], featured: false },
  { id: 'd012', name: '日韩资讯速递', url: 'https://www.rh-news.fun', category: 'news', status: 'online', updateTime: '2026-08-12', visits: 89000, description: '日韩娱乐八卦、明星动态、影视资讯一手掌握，每日更新热点新闻。', tags: ['资讯', '娱乐', '明星'], featured: false },
  { id: 'd013', name: '声优广播站', url: 'https://www.seiyuu-radio.net', category: 'music', status: 'online', updateTime: '2026-08-08', visits: 45000, description: '日本声优广播节目在线收听，花江夏树、松岡禎丞等知名声优节目完整收录。', tags: ['声优', '广播', '日本'], featured: false },
  { id: 'd014', name: '日韩直播厅', url: 'https://www.rh-live.live', category: 'live', status: 'online', updateTime: '2026-08-11', visits: 61000, description: '日韩主播直播聚合平台，游戏直播、聊天直播、才艺直播应有尽有。', tags: ['直播', '游戏', '才艺'], featured: false },
  { id: 'd015', name: '怀旧日漫馆', url: 'https://www.old-anime.club', category: 'anime', status: 'online', updateTime: '2026-08-06', visits: 72000, description: '80/90年代经典日漫在线重温，哆啦A梦、龙珠、灌篮高手等童年回忆全收录。', tags: ['经典', '怀旧', '童年'], featured: true },
  { id: 'd016', name: '日综笑料厂', url: 'https://www.jp-variety.lol', category: 'variety', status: 'online', updateTime: '2026-08-10', visits: 48000, description: '日本搞笑综艺精选，月曜夜未央、VS岚等节目让你笑到停不下来。', tags: ['日综', '搞笑', '月曜'], featured: false },
];

export const articles = [
  {
    id: 'a001',
    title: '如何找到稳定的日韩在线观看域名？终极指南',
    slug: 'how-to-find-stable-domain',
    category: 'news',
    publishDate: '2026-08-10',
    updateDate: '2026-08-12',
    author: '域名小助手',
    excerpt: '本文将教您如何找到并收藏稳定的日韩在线域名，避免频繁换址的烦恼，确保观影体验不中断。',
    content: `<p>对于喜爱日韩内容的用户来说，最令人头疼的问题莫过于经常需要寻找新的访问地址。域名被屏蔽、服务器迁移、DNS污染等问题频发，导致收藏的网址经常失效。本文将为您提供一套完整的域名稳定访问解决方案。</p>
<h2>为什么域名会频繁失效？</h2>
<p>日韩在线内容网站的域名频繁失效主要有以下几个原因：DNS污染和劫持是最常见的技术问题，某些网络环境下域名解析会被干扰；版权方的投诉可能导致域名被注销；服务器端的主动迁移也是常见原因之一。了解这些原因后，我们才能有针对性地采取措施。</p>
<h2>如何选择稳定的域名？</h2>
<p>选择稳定的日韩在线域名需要注意以下几点：优先选择使用国际顶级域名的站点，如.com、.net、.org等，这些域名注册商对版权投诉的处理相对规范；关注域名的注册时长，注册时间越长的域名通常越稳定；选择有备用域名机制的站点，当主域名失效时可以自动跳转。</p>
<h2>收藏本站，一劳永逸</h2>
<p>本站"日韩在线永久域名"致力于收录和维护最新、最稳定的日韩在线域名地址。我们的团队24小时监控域名状态，一旦发现失效立即更新。将本页加入书签，您就拥有了一个永不丢失的日韩内容访问入口。</p>
<h2>使用建议</h2>
<p>建议您同时收藏本站的多个备用域名，以防万一。此外，关注我们的社交媒体账号也是获取最新域名更新的好方法。我们的域名更新频率为每日一次，确保您始终能够访问到最新的有效域名。</p>`,
    tags: ['域名', '指南', '稳定性'],
    visits: 32000,
    relatedDomainIds: ['d001', 'd002', 'd003'],
  },
  {
    id: 'a002',
    title: '2026年最受欢迎的日韩动漫在线观看域名推荐',
    slug: 'best-anime-domains-2026',
    category: 'anime',
    publishDate: '2026-08-08',
    updateDate: '2026-08-11',
    author: '动漫观察员',
    excerpt: '盘点2026年最受欢迎的日韩动漫在线观看域名，为您推荐高速、高清、稳定的动漫观看入口。',
    content: `<p>2026年，日韩动漫产业持续蓬勃发展，越来越多的优质动漫作品涌现。为了帮助动漫爱好者找到最佳的在线观看体验，我们精心筛选了当前最受欢迎的动漫域名推荐。</p>
<h2>樱花动漫岛 - 日漫爱好者的首选</h2>
<p>樱花动漫岛以其海量的日漫资源和稳定的播放体验赢得了大量用户的青睐。该站每日更新最新番剧，支持1080P高清播放，弹幕系统也让观看体验更加有趣。</p>
<h2>东京动漫城 - 综合性动漫平台</h2>
<p>东京动漫城是一个综合性的动漫平台，不仅提供日漫，还涵盖国漫和欧美动漫。其独特的推荐算法能根据您的观看历史智能推荐您可能喜欢的作品。</p>
<h2>选择建议</h2>
<p>建议动漫爱好者同时收藏2-3个不同的动漫域名入口，这样即使某一个暂时无法访问，也能迅速切换到备用站点，不影响追番体验。将本站所有动漫域名一并收藏，是最保险的做法。</p>`,
    tags: ['动漫', '推荐', '2026'],
    visits: 28000,
    relatedDomainIds: ['d001', 'd003', 'd008'],
  },
  {
    id: 'a003',
    title: '韩剧迷必看：2026年韩剧在线观看域名完全收录',
    slug: 'korean-drama-domains-2026',
    category: 'video',
    publishDate: '2026-08-09',
    updateDate: '2026-08-12',
    author: '韩剧达人',
    excerpt: '韩剧迷必备！2026年最新韩剧在线观看域名完全收录，从此告别找资源的痛苦。',
    content: `<p>韩剧在全球范围内持续火爆，从《黑暗荣耀》到《眼泪女王》，每一部热门韩剧都引发追剧热潮。但对于国内观众来说，如何找到稳定的韩剧观看入口一直是个难题。本文为您整理了2026年最稳定的韩剧在线观看域名。</p>
<h2>韩剧星球 - 最新韩剧一网打尽</h2>
<p>韩剧星球是目前最全面的韩剧在线观看平台之一，涵盖热播韩剧、经典韩影和韩国综艺。中文字幕团队24小时在线翻译，确保您在第一时间就能看到带有中文字幕的最新剧集。</p>
<h2>日剧时光机 - 日韩剧集全收录</h2>
<p>除了韩剧，日剧时光机也收录了大量经典和最新的日剧资源，对于同时喜欢日剧和韩剧的观众来说，这是一个理想的一站式平台。</p>
<h2>追剧小贴士</h2>
<p>建议使用本站收录的多个域名交替使用，并定期关注我们的域名更新公告。当您发现某个域名访问缓慢时，可以尝试切换到其他域名，通常能获得更好的观看体验。</p>`,
    tags: ['韩剧', '推荐', '追剧'],
    visits: 35000,
    relatedDomainIds: ['d002', 'd006', 'd009'],
  },
  {
    id: 'a004',
    title: '日韩音乐粉丝必收：J-POP和K-POP在线域名大全',
    slug: 'jpop-kpop-music-domains',
    category: 'music',
    publishDate: '2026-08-07',
    updateDate: '2026-08-11',
    author: '音乐猎人',
    excerpt: 'J-POP和K-POP粉丝的福利！最全的日韩音乐在线观看和收听域名大全，MV、打歌舞台一应俱全。',
    content: `<p>日韩音乐在全球拥有庞大的粉丝群体，从J-POP的独特魅力到K-POP的国际化浪潮，日韩音乐的影响力与日俱增。本文为您整理了最全面的日韩音乐在线域名。</p>
<h2>J-POP音乐站 - 日音爱好者的天堂</h2>
<p>J-POP音乐站收录了大量日本流行音乐的MV、演唱会和音乐节目资源。从经典歌手到新生代团体，您能在这里找到几乎所有喜欢的日本音乐内容。</p>
<h2>K-POP星空 - 韩流音乐聚集地</h2>
<p>K-POP星空是韩流音乐粉丝的必收站点，提供最新的打歌舞台、MV首播和综艺放送。所有内容均提供高清画质，让您不错过偶像的每一个精彩瞬间。</p>
<h2>声优广播站 - 二次元声控福利</h2>
<p>对于喜欢日本声优的粉丝来说，声优广播站是一个宝藏站点，收录了大量知名声优的广播节目和访谈内容。</p>`,
    tags: ['音乐', 'J-POP', 'K-POP'],
    visits: 21000,
    relatedDomainIds: ['d005', 'd007', 'd013'],
  },
  {
    id: 'a005',
    title: '域名被屏蔽了怎么办？日韩在线访问故障排除指南',
    slug: 'domain-blocked-solution',
    category: 'news',
    publishDate: '2026-08-06',
    updateDate: '2026-08-12',
    author: '技术小帮手',
    excerpt: '域名突然访问不了？别慌！本文提供完整的故障排除方案，帮助您快速恢复日韩在线内容的访问。',
    content: `<p>当您收藏的日韩在线域名突然无法访问时，不要慌张。这种情况虽然令人沮丧，但通常有解决方案。本文将为您提供一套完整的故障排除流程。</p>
<h2>第一步：确认问题类型</h2>
<p>首先需要判断无法访问的具体原因：是域名解析失败（显示"无法找到服务器"），还是连接被重置（页面加载一半后断开），或者是域名被跳转到其他页面。不同的情况对应不同的解决方案。</p>
<h2>第二步：尝试备用域名</h2>
<p>大多数日韩在线内容站都提供了多个备用域名。您可以访问本站查询该站点的最新可用域名列表，我们每天都会更新域名状态。</p>
<h2>第三步：使用本站搜索</h2>
<p>如果上述方法都不奏效，可以使用本站的搜索功能查找同类型的替代站点。我们的域名库收录了数十个优质日韩在线域名，总有一个能帮到您。</p>
<h2>预防措施</h2>
<p>最有效的预防措施就是将本站收藏为书签，并关注我们的更新通知。这样您就永远不用担心找不到可用的日韩在线域名了。</p>`,
    tags: ['故障排除', '域名', '解决方案'],
    visits: 19000,
    relatedDomainIds: [],
  },
  {
    id: 'a006',
    title: '日韩综艺节目在线观看域名推荐：搞笑与治愈并存',
    slug: 'japanese-korean-variety-domains',
    category: 'variety',
    publishDate: '2026-08-05',
    updateDate: '2026-08-11',
    author: '综艺爱好者',
    excerpt: '日韩综艺节目以其独特的搞笑风格和治愈氛围深受欢迎。本文推荐最稳定的日韩综艺在线观看域名。',
    content: `<p>日韩综艺节目在全球范围内拥有独特的魅力——日本综艺以其无厘头的搞笑和创意企划著称，而韩国综艺则以明星互动和真实情感打动观众。本文为您推荐最稳定的日韩综艺在线观看域名。</p>
<h2>韩综大本营 - 韩综迷的快乐源泉</h2>
<p>韩综大本营收录了从经典到最新的韩国综艺节目，包括Running Man、无限挑战、认识的哥哥等热门节目，均提供中文字幕。</p>
<h2>日综笑料厂 - 笑到停不下来</h2>
<p>日综笑料厂专注于日本搞笑综艺，月曜夜未央、VS岚、交给岚吧等经典节目完整收录，让您在欢笑中度过每一天。</p>
<h2>日韩综艺汇 - 一站式综艺平台</h2>
<p>日韩综艺汇是一个覆盖日韩两国综艺节目的综合平台，无论您喜欢哪种风格的综艺，都能在这里找到心仪的内容。</p>`,
    tags: ['综艺', '推荐', '日综', '韩综'],
    visits: 16000,
    relatedDomainIds: ['d004', 'd010', 'd016'],
  },
];